import React from "react";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";

interface SelectProps {
  options: { value: string; label: string }[];
  value: string;
  onChange: (event: DropdownChangeEvent) => void;
  label: string;
  id: string;
  required?: boolean;
  disabled?: boolean;
}

const Select: React.FC<SelectProps> = ({
  options,
  value,
  onChange,
  label,
  id,
  required = false,
  disabled = false,
}) => {
  return (
    <div className="form-group">
      <label htmlFor={id} className="form-label">
        {label} {required && <span style={{ color: "red" }}>*</span>}
      </label>
      <Dropdown
        id={id}
        name={id}
        value={value}
        options={options}
        onChange={onChange}
        placeholder="Seleccionar una opción"
        className="form-select"
        disabled={disabled}
      />
      {required && !value && (
        <small className="p-error">Este campo es obligatorio</small>
      )}
    </div>
  );
};

export default Select;
